(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2957"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2957"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("koLG2", function(module, exports) {

$parcel$export(module.exports, "initDetailsAccordion", function () { return $b12cef79cc123d2b$export$45b65a693d4d6ae1; });
/**
 * Makes a group of <details> elements inside a container behave like an accordion:
 * opening one automatically closes any other currently open element matching the selector.
 *
 * Uses a single delegated listener on the container instead of one per <details>,
 * so it also picks up elements added to the DOM later.
 *
 * Note: the native `toggle` event does not bubble, so the listener is registered
 * in the capture phase — capturing still fires for non-bubbling events.
 */ const $b12cef79cc123d2b$export$45b65a693d4d6ae1 = ($container, detailsSelector)=>{
    const isMatchingOpenDetails = ($target)=>$target instanceof HTMLDetailsElement && $target.matches(detailsSelector) && $target.open;
    $container.addEventListener('toggle', (event)=>{
        const $toggledDetails = event.target;
        if (!isMatchingOpenDetails($toggledDetails)) return;
        const $allDetails = $container.querySelectorAll(`${detailsSelector}[open]`);
        $allDetails.forEach(($details)=>{
            if ($details !== $toggledDetails) $details.removeAttribute('open');
        });
    }, true);
};

});

parcelRegister("d8tQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90c4571c3a376e78$export$2e2bcd8739ae039; });

var $knCXs = parcelRequire("knCXs");

var $9KW2j = parcelRequire("9KW2j");
/**
 * Populates dialog image element with QR code data from the opener element's data attributes.
 *
 * @param dialogImage - The image element inside the dialog to populate
 * @param opener - The element that triggered the dialog
 *
 * @example
 * Opener element should have these data attributes:
 * <button data-qr-opener data-qr-src="image.png" data-qr-alt="QR Code" data-qr-width="200" data-qr-height="200">Open QR</button>
 */ const $90c4571c3a376e78$var$setDialogImageFromOpener = (dialogImage, opener)=>{
    const qrSrc = opener.getAttribute('data-qr-src') ?? '';
    const qrAlt = opener.getAttribute('data-qr-alt') ?? '';
    const qrWidth = opener.getAttribute('data-qr-width');
    const qrHeight = opener.getAttribute('data-qr-height');
    if (!qrSrc) return;
    dialogImage.src = qrSrc;
    dialogImage.alt = qrAlt;
    if (qrWidth) dialogImage.width = Number(qrWidth);
    if (qrHeight) dialogImage.height = Number(qrHeight);
};
/**
 * Handles a click on a QR opener element.
 * On desktop: shows the QR modal populated with the opener's QR image.
 * On mobile/touch: redirects to the app download link from `data-app-download-link`.
 *
 * @param opener - The clicked element with `data-qr-*` and `data-app-download-link` attributes
 * @param dialog - The global QR dialog element
 * @param dialogImage - The image element inside the dialog
 */ const $90c4571c3a376e78$var$handleOpenerClick = (opener, dialog, dialogImage)=>{
    if ((0, $9KW2j.isMobileDevice)()) {
        const link = opener.getAttribute('data-app-download-link');
        if (link) window.location.href = link;
        return;
    }
    $90c4571c3a376e78$var$setDialogImageFromOpener(dialogImage, opener);
    if (typeof HTMLDialogElement === 'function') dialog.showModal();
    else dialog.removeAttribute('hidden');
};
/**
 * Initializes the global QR code popup.
 * Finds all `[data-qr-opener]` elements and attaches click handlers.
 * Requires `[data-qr-dialog-global]` and `[data-qr-dialog-image]` to be present in the DOM.
 */ const $90c4571c3a376e78$var$initQrPopup = ()=>{
    const dialog = document.querySelector('[data-qr-dialog-global]');
    const openers = Array.from(document.querySelectorAll('[data-qr-opener]'));
    if (!dialog || !openers.length) {
        console.error('QR popup initialization failed:', {
            dialogFound: Boolean(dialog),
            openerCount: openers.length
        });
        return;
    }
    const dialogImage = dialog.querySelector('[data-qr-dialog-image]');
    if (!dialogImage) {
        console.error('QR popup initialization failed: dialog image not found.');
        return;
    }
    openers.forEach((opener)=>{
        opener.addEventListener('click', ()=>$90c4571c3a376e78$var$handleOpenerClick(opener, dialog, dialogImage));
    });
    (0, $knCXs.modalHandle)(dialog);
};
var $90c4571c3a376e78$export$2e2bcd8739ae039 = $90c4571c3a376e78$var$initQrPopup;

});
parcelRegister("knCXs", function(module, exports) {

$parcel$export(module.exports, "modalHandle", function () { return $9258b8f367a9c85a$export$eaa6d74f8f42be11; });
/**
 * Sets up a dialog element to function as a tooltip that appears when hovering over a specified element.
 *
 * This function:
 * - Handles browser compatibility for the HTML Dialog element
 * - If the browser supports HTMLDialogElement, it uses the native show/close methods
 * - If not supported, it falls back to using the hidden attribute
 * - Sets the dialog parent's position to 'relative'
 * - Adds a 'tooltip' class to the dialog element
 *
 * @param dialog - The HTML dialog element to be displayed as a tooltip
 * @param dialogOpener - The element that triggers the dialog when hovered over
 *
 * @example
 * ```typescript
 * const dialog = document.querySelector<HTMLDialogElement>('#my-tooltip');
 * const opener = document.querySelector<HTMLElement>('#tooltip-opener');
 *
 * if (dialog && opener) {
 *   dialogHandle(dialog, opener);
 * }
 * ```
 */ const $9258b8f367a9c85a$export$f4caa643aa66c9b9 = (dialog, dialogOpener)=>{
    dialog.parentElement.style.position = 'relative';
    dialog.classList.add('tooltip');
    // check if dialog tag is supported
    if (typeof HTMLDialogElement === 'function') {
        dialog.removeAttribute('hidden');
        dialogOpener.addEventListener('mouseenter', ()=>dialog.show());
        dialogOpener.addEventListener('mouseout', ()=>dialog.close());
    } else {
        dialog.setAttribute('hidden', '');
        dialogOpener.addEventListener('mouseenter', ()=>dialog.removeAttribute('hidden'));
        dialogOpener.addEventListener('mouseout', ()=>dialog.setAttribute('hidden', ''));
    }
};
const $9258b8f367a9c85a$export$eaa6d74f8f42be11 = (modal, modalOpeners)=>{
    const closeBtn = modal.querySelector('[data-modal-close]');
    // Handle multiple openers or single opener
    const attachOpenEvent = (opener, action)=>{
        opener.addEventListener('click', action);
    };
    const setupOpeners = (action)=>{
        if (!modalOpeners) return;
        if (Array.isArray(modalOpeners)) modalOpeners.forEach((opener)=>attachOpenEvent(opener, action));
        else attachOpenEvent(modalOpeners, action);
    };
    // check if dialog tag is supported
    if (typeof HTMLDialogElement === 'function') {
        modal.removeAttribute('hidden');
        setupOpeners(()=>modal.showModal());
        modal.addEventListener('click', (e)=>{
            if (e.detail === 0) return; // ignore focus events
            const dialogDimensions = modal.getBoundingClientRect();
            if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) modal.close();
        });
        if (closeBtn) closeBtn.addEventListener('click', ()=>modal.close());
    } else {
        modal.setAttribute('hidden', '');
        setupOpeners(()=>modal.removeAttribute('hidden'));
        modal.addEventListener('click', (e)=>{
            const dialogDimensions = modal.getBoundingClientRect();
            if (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom) modal.setAttribute('hidden', '');
        });
        if (closeBtn) closeBtn.addEventListener('click', ()=>modal.setAttribute('hidden', ''));
    }
};

});

parcelRegister("9KW2j", function(module, exports) {

$parcel$export(module.exports, "isAndroid", function () { return $9b42097cc816bb4d$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isMobileDevice", function () { return $9b42097cc816bb4d$export$44f917bf91becd01; });
$parcel$export(module.exports, "isAppInstalled", function () { return $9b42097cc816bb4d$export$4fe30fcd38d81a35; });
const $9b42097cc816bb4d$export$a11b0059900ceec8 = ()=>{
    return /Android/i.test(navigator.userAgent);
};
const $9b42097cc816bb4d$export$44f917bf91becd01 = ()=>{
    const userAgent = navigator.userAgent.toLowerCase();
    const isStandardMobile = /android|iphone|ipad|ipod/.test(userAgent);
    const isNewIPad = userAgent.includes('mac') && navigator.maxTouchPoints > 0;
    return isStandardMobile || isNewIPad;
};
const $9b42097cc816bb4d$export$4fe30fcd38d81a35 = async (appId)=>{
    if (!navigator.getInstalledRelatedApps) return false;
    try {
        const relatedApps = await navigator.getInstalledRelatedApps();
        return relatedApps.some((app)=>app.id === appId);
    } catch (error) {
        console.error(error);
        return false;
    }
};

});


parcelRegister("jmFFy", function(module, exports) {

$parcel$export(module.exports, "initFAQ", function () { return $84c9ae54eae311c3$export$91c34452fd189695; });

var $koLG2 = parcelRequire("koLG2");
const $84c9ae54eae311c3$var$acordeonFeature = ()=>{
    const $faqContainer = document.querySelector('[data-js="faq"]');
    if (!$faqContainer) return;
    (0, $koLG2.initDetailsAccordion)($faqContainer, '[data-js="faq-item"]');
};
const $84c9ae54eae311c3$export$91c34452fd189695 = ()=>{
    $84c9ae54eae311c3$var$acordeonFeature();
};

});

/**
 * Number of cards shown on initial render for every tab.
 * Always fixed at 12 regardless of total count.
 */ const $b976c7c5625400c1$export$90091b93f6cf4241 = 12;
const $b976c7c5625400c1$export$8f68af429cdd2753 = 48;
const $b976c7c5625400c1$export$6ba5cf23702d4bc1 = 4;



const $0b9e4ec86215eb0d$export$c73bd88bc6042fa0 = (total)=>{
    if (total <= (0, $b976c7c5625400c1$export$8f68af429cdd2753)) return total;
    return Math.ceil((total - (0, $b976c7c5625400c1$export$90091b93f6cf4241)) / (0, $b976c7c5625400c1$export$6ba5cf23702d4bc1));
};
const $0b9e4ec86215eb0d$export$94a1e481d2baa0cc = (tabs)=>Object.fromEntries(tabs.map((tab)=>[
            tab,
            (0, $b976c7c5625400c1$export$90091b93f6cf4241)
        ]));


/**
 * Marks cards with a staggered enter animation class.
 * The delay is driven by --stagger-index CSS custom property.
 * The animationend listener cleans up immediately so active CSS animations
 * don't block future opacity transitions (e.g. collapse).
 */ const $d9f722433aa9bee0$export$57b0fa8a14d39334 = ($cards)=>{
    $cards.forEach(($card, i)=>{
        $card.style.setProperty('--stagger-index', String(i));
        $card.classList.add('is-entering');
        $card.addEventListener('animationend', ()=>{
            $card.classList.remove('is-entering');
            $card.style.removeProperty('--stagger-index');
        }, {
            once: true
        });
    });
};
/** Measures the height the list would have after cardsToHide are removed. */ const $d9f722433aa9bee0$var$measureCollapsedHeight = ($list, $cardsToHide)=>{
    $cardsToHide.forEach(($c)=>$c.setAttribute('hidden', ''));
    const height = $list.scrollHeight;
    $cardsToHide.forEach(($c)=>$c.removeAttribute('hidden'));
    return height;
};
/** Locks the list at a fixed pixel height so it can be transitioned. */ const $d9f722433aa9bee0$var$lockList = ($list, height)=>{
    $list.style.height = `${height}px`;
    $list.style.overflow = 'hidden';
};
/** Removes all inline styles added during collapse and strips CSS classes from cards. */ const $d9f722433aa9bee0$var$releaseList = ($list, $cards)=>{
    $list.style.height = '';
    $list.style.overflow = '';
    $list.style.transition = '';
    $cards.forEach(($c)=>$c.classList.remove('is-collapsing'));
};
const $d9f722433aa9bee0$export$cf6c179ea1999aa = ($offersList, $cardsToHide, onDone)=>{
    if ($cardsToHide.length === 0) {
        onDone();
        return;
    }
    const currentHeight = $offersList.scrollHeight;
    const targetHeight = $d9f722433aa9bee0$var$measureCollapsedHeight($offersList, $cardsToHide);
    $d9f722433aa9bee0$var$lockList($offersList, currentHeight);
    $cardsToHide.forEach(($c)=>$c.classList.add('is-collapsing'));
    // Force layout — browser must commit currentHeight before we animate to targetHeight
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    $offersList.offsetHeight;
    $offersList.style.transition = 'height 0.4s ease';
    $offersList.style.height = `${targetHeight}px`;
    const onTransitionEnd = (e)=>{
        if (e.propertyName !== 'height') return;
        $offersList.removeEventListener('transitionend', onTransitionEnd);
        $d9f722433aa9bee0$var$releaseList($offersList, $cardsToHide);
        onDone();
    };
    $offersList.addEventListener('transitionend', onTransitionEnd);
};


const $af877fa2e1551329$var$queryElements = ($root)=>({
        $tabButtons: Array.from($root.querySelectorAll('[data-js="price-list-tab"]')),
        $items: Array.from($root.querySelectorAll('li[data-tab]')),
        $showMoreBtn: $root.querySelector('[data-js="price-list-show-more"]'),
        $collapseBtn: $root.querySelector('[data-js="price-list-collapse"]'),
        $counterVisible: $root.querySelector('[data-js="price-list-counter-visible-value"]'),
        $counterTotal: $root.querySelector('[data-js="price-list-counter-total-value"]'),
        $offersList: $root.querySelector('.esim-price-list__offers-list')
    });
const $af877fa2e1551329$var$getTabItems = ($items, tab)=>$items.filter(($item)=>$item.dataset.tab === tab);
function $af877fa2e1551329$export$7f0714058b835a49($root) {
    const { $tabButtons: $tabButtons, $items: $items, $showMoreBtn: $showMoreBtn, $collapseBtn: $collapseBtn, $counterVisible: $counterVisible, $counterTotal: $counterTotal, $offersList: $offersList } = $af877fa2e1551329$var$queryElements($root);
    const tabs = [
        ...new Set($items.map(($item)=>$item.dataset.tab ?? ''))
    ];
    const state = {
        activeTab: 'popular',
        visibleCount: (0, $0b9e4ec86215eb0d$export$94a1e481d2baa0cc)(tabs)
    };
    const cancelAnimations = ()=>{
        if ($offersList) {
            $offersList.style.height = '';
            $offersList.style.overflow = '';
            $offersList.style.transition = '';
        }
        $items.forEach(($item)=>{
            $item.classList.remove('is-entering', 'is-collapsing');
            $item.style.removeProperty('--stagger-index');
        });
    };
    const updateVisibility = ($tabItems, visible)=>{
        $items.forEach(($item)=>$item.setAttribute('hidden', ''));
        $tabItems.slice(0, visible).forEach(($item)=>$item.removeAttribute('hidden'));
    };
    const updateTabNav = ()=>{
        $tabButtons.forEach(($btn)=>{
            $btn.classList.toggle('button--transparent', $btn.dataset.tab !== state.activeTab);
        });
    };
    const updateFooter = (visible, total)=>{
        if ($counterVisible) $counterVisible.textContent = String(visible);
        if ($counterTotal) $counterTotal.textContent = String(total);
        $showMoreBtn?.toggleAttribute('hidden', visible >= total);
        $collapseBtn?.toggleAttribute('hidden', visible <= (0, $b976c7c5625400c1$export$90091b93f6cf4241));
    };
    const render = ()=>{
        const { activeTab: activeTab, visibleCount: visibleCount } = state;
        const $tabItems = $af877fa2e1551329$var$getTabItems($items, activeTab);
        const total = $tabItems.length;
        const visible = Math.min(visibleCount[activeTab] ?? (0, $b976c7c5625400c1$export$90091b93f6cf4241), total);
        cancelAnimations();
        updateVisibility($tabItems, visible);
        updateTabNav();
        updateFooter(visible, total);
    };
    $tabButtons.forEach(($btn)=>{
        $btn.addEventListener('click', ()=>{
            state.activeTab = $btn.dataset.tab ?? 'popular';
            render();
        });
    });
    $showMoreBtn?.addEventListener('click', ()=>{
        const $tabItems = $af877fa2e1551329$var$getTabItems($items, state.activeTab);
        const prevCount = state.visibleCount[state.activeTab] ?? (0, $b976c7c5625400c1$export$90091b93f6cf4241);
        const previousVisible = Math.min(prevCount, $tabItems.length);
        const step = (0, $0b9e4ec86215eb0d$export$c73bd88bc6042fa0)($tabItems.length);
        state.visibleCount[state.activeTab] = prevCount + step;
        const nextVisible = Math.min(state.visibleCount[state.activeTab], $tabItems.length);
        const $newCards = $tabItems.slice(previousVisible, nextVisible);
        // render() first (reveals cards and clears previous animations), then markEntering()
        // — both run synchronously before the browser paints, so no flash
        render();
        (0, $d9f722433aa9bee0$export$57b0fa8a14d39334)($newCards);
    });
    $collapseBtn?.addEventListener('click', ()=>{
        const $tabItems = $af877fa2e1551329$var$getTabItems($items, state.activeTab);
        const currentVisible = Math.min(state.visibleCount[state.activeTab] ?? (0, $b976c7c5625400c1$export$90091b93f6cf4241), $tabItems.length);
        const $cardsToHide = $tabItems.slice((0, $b976c7c5625400c1$export$90091b93f6cf4241), currentVisible);
        $root.scrollIntoView({
            block: 'start'
        });
        if (!$offersList) {
            state.visibleCount[state.activeTab] = (0, $b976c7c5625400c1$export$90091b93f6cf4241);
            render();
            return;
        }
        (0, $d9f722433aa9bee0$export$cf6c179ea1999aa)($offersList, $cardsToHide, ()=>{
            state.visibleCount[state.activeTab] = (0, $b976c7c5625400c1$export$90091b93f6cf4241);
            render();
        });
    });
    render();
}



var $koLG2 = parcelRequire("koLG2");
function $0cf215dcf2a70697$var$initBrandsAccordion($root) {
    const $hasBrands = $root.querySelector('[data-js="esim-devices-brand"]') !== null;
    if (!$hasBrands) return;
    (0, $koLG2.initDetailsAccordion)($root, '[data-js="esim-devices-brand"]');
}
function $0cf215dcf2a70697$export$c2b0b1e7547240ca($root) {
    const $tabs = Array.from($root.querySelectorAll('[role="tab"]'));
    const $panels = Array.from($root.querySelectorAll('[role="tabpanel"]'));
    $0cf215dcf2a70697$var$initBrandsAccordion($root);
    function activateTab($targetTab) {
        const targetKey = $targetTab.dataset.tab;
        $tabs.forEach(($tab)=>{
            const isActive = $tab === $targetTab;
            $tab.setAttribute('aria-selected', String(isActive));
            $tab.classList.toggle('button--transparent', !isActive);
        });
        $panels.forEach(($panel)=>{
            const isActive = $panel.id === `esim-devices-panel-${targetKey}`;
            $panel.classList.toggle('is-active', isActive);
            if (isActive) $panel.removeAttribute('hidden');
            else $panel.setAttribute('hidden', '');
        });
    }
    $tabs.forEach(($tab)=>{
        $tab.addEventListener('click', ()=>activateTab($tab));
    });
}



var $d8tQ2 = parcelRequire("d8tQ2");

var $jmFFy = parcelRequire("jmFFy");
const $8ee28d3f08c3132b$var$$priceListRoot = document.querySelector('[data-js="esim-price-list"]');
if ($8ee28d3f08c3132b$var$$priceListRoot) (0, $af877fa2e1551329$export$7f0714058b835a49)($8ee28d3f08c3132b$var$$priceListRoot);
const $8ee28d3f08c3132b$var$$devicesRoot = document.querySelector('[data-js="esim-devices"]');
if ($8ee28d3f08c3132b$var$$devicesRoot) (0, $0cf215dcf2a70697$export$c2b0b1e7547240ca)($8ee28d3f08c3132b$var$$devicesRoot);
(0, $d8tQ2.default)();
(0, $jmFFy.initFAQ)();

})();
//# sourceMappingURL=script.js.map
